var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12434_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2893 2.77336L9.33262 0.806697C9.20332 0.678052 9.02835 0.605835 8.84595 0.605835C8.66356 0.605835 8.48858 0.678052 8.35929 0.806697L1.42262 7.73336L0.789286 10.4667C0.767439 10.5666 0.768188 10.6702 0.791479 10.7697C0.81477 10.8693 0.860014 10.9625 0.923908 11.0423C0.987801 11.1222 1.06873 11.1868 1.16078 11.2314C1.25283 11.276 1.35368 11.2994 1.45595 11.3C1.50361 11.3048 1.55163 11.3048 1.59929 11.3L4.36262 10.6667L11.2893 3.7467C11.4179 3.6174 11.4901 3.44242 11.4901 3.26003C11.4901 3.07764 11.4179 2.90266 11.2893 2.77336ZM4.02929 10.0667L1.43929 10.61L2.02929 8.07003L7.21929 2.90003L9.21929 4.90003L4.02929 10.0667ZM9.66595 4.4167L7.66595 2.4167L8.82595 1.26336L10.7926 3.26336L9.66595 4.4167Z",
    fill: "#00693E",
    stroke: "#00693E",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12434_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit-green.c53460c3587f8a520dc2e75c28a5f168.svg";
export { ForwardRef as ReactComponent };